import { ChangeDetectionStrategy, Component, OnDestroy, inject } from "@angular/core";
import { Router } from "@angular/router";

import { SidebarButtonBase } from "@logex/framework/lg-layout";
import { Subscription } from "rxjs";

@Component({
    selector: "sidebar-dashboard",
    template: `<div class="{{ imageClass }} lg-sidebar-btn__image"></div>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SidebarButtonDashboardComponent extends SidebarButtonBase implements OnDestroy {
    private _subscription = new Subscription();

    constructor() {
        super();

        const router = inject(Router);

        this.imageClass = "lg-sidebar-btn__image--no-text logo-appropriate-care__bg--transparent";

        this._subscription = this.onClick.subscribe(() => {
            router.navigateByUrl("/dashboard");
        });
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this._subscription.unsubscribe();
    }
}
